export default function ordCreateInvoice(data){
    const params = {action: "ord_create_invoice", record : data.id};

    var self = this;

    this.rest.post("customAction", params, function(resp) {
        if(resp.status){
            self.href("#detail/acm_invoices/"+resp.message.data.record);
        }
        else{
            self.alert(resp.errorMessage.text);
        }
    });
}
